import type { SiteConfig, Testimonial } from '../../../siteContentTypes.ts';
import { TextField, TextAreaField, NumberField, ImageField, SelectField, ToggleField, ListEditor } from './fields.tsx';

export function TestimonialsSection({ config, update }: { config: SiteConfig; update: (patch: Partial<SiteConfig>) => void }) {
  const t = config.testimonials;
  const set = (patch: Partial<SiteConfig['testimonials']>) => update({ testimonials: { ...t, ...patch } });

  return (
    <div>
      <h2 style={{ fontSize: 18, fontWeight: 800, marginBottom: 20 }}>Témoignages</h2>
      <div className="error-banner" style={{ marginBottom: 16 }}>
        Ces avis sont des exemples de démonstration tant qu'ils n'ont pas été remplacés par de vrais retours clients.
      </div>
      <TextField label="Titre de la section" value={t.title} onChange={(v) => set({ title: v })} />
      <SelectField
        label="Mode d'affichage"
        value={t.displayMode}
        onChange={(v) => set({ displayMode: v })}
        options={[{ value: 'carousel', label: 'Carrousel' }, { value: 'grid', label: 'Grille' }]}
      />

      <ListEditor<Testimonial>
        items={t.items}
        onChange={(items) => set({ items })}
        itemLabel="un témoignage"
        newItem={() => ({
          id: crypto.randomUUID(),
          firstName: 'Prénom',
          lastName: '',
          role: '',
          company: '',
          photo: '',
          text: '',
          rating: 5,
          location: '',
          type: 'EXTRA',
          date: '',
          order: t.items.length,
          visible: true,
        })}
        renderItem={(item, patch) => (
          <>
            <div style={{ display: 'flex', gap: 10 }}>
              <div style={{ flex: 1 }}>
                <TextField label="Prénom" value={item.firstName} onChange={(v) => patch({ firstName: v })} />
              </div>
              <div style={{ flex: 1 }}>
                <TextField label="Nom" value={item.lastName} onChange={(v) => patch({ lastName: v })} />
              </div>
            </div>
            <TextField label="Fonction" value={item.role} onChange={(v) => patch({ role: v })} />
            <TextField label="Entreprise" value={item.company} onChange={(v) => patch({ company: v })} />
            <ImageField label="Photo" value={item.photo} onChange={(v) => patch({ photo: v })} />
            <TextAreaField label="Texte" value={item.text} onChange={(v) => patch({ text: v })} />
            <NumberField label="Note (1-5)" value={item.rating} onChange={(v) => patch({ rating: v })} />
            <TextField label="Localisation" value={item.location} onChange={(v) => patch({ location: v })} />
            <SelectField
              label="Type"
              value={item.type}
              onChange={(v) => patch({ type: v })}
              options={[
                { value: 'EXTRA', label: 'Extra' },
                { value: 'RESTAURATEUR', label: 'Restaurateur' },
                { value: 'TRAITEUR', label: 'Traiteur' },
              ]}
            />
            <ToggleField label="Visible" value={item.visible} onChange={(v) => patch({ visible: v })} />
          </>
        )}
      />
    </div>
  );
}
